var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',_vm._b({staticClass:"Form",style:({
		'--color': _vm.config.color || 'var(--clrTheme)',
		'--backgroundColor': _vm.config.backgroundColor || '#F4F4F4',
		'--textColor': _vm.config.textColor || '#666',
		'--titleColor': _vm.config.titleColor || '#444'
	})},'form',_vm.$attrs,false),_vm._l((_vm.form),function(entry){return _c(_vm.getElement(entry.type),_vm._b({key:entry.name,tag:"element",attrs:{"value":_vm.cache[entry.name],"formId":_vm.formId},on:{"change":function($event){return _vm.onChange(entry.name, $event)}}},'element',entry,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }